import { Box, FormLabel, Select, Text } from "@chakra-ui/react";
import React from "react";

export default function CustomSelect({ label, error, ...rest }) {
  const validation = error && typeof error === "object" ? error : null;
  const message = validation ? validation.message : error;
  const hasError = validation ? validation.isError : Boolean(error);
  return (
    <Box
      className="custom-form-control"
      data-validation-state={hasError ? "error" : message ? "success" : ""}
    >
      <FormLabel fontSize="sm">{label}</FormLabel>
      <Select
        size="sm"
        borderColor={hasError ? "red" : message ? "green" : "gray.300"}
        {...rest}
      >
        {rest?.options?.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      {message && (
        <Text
          className="validation-message"
          fontSize="xs"
          color={hasError ? "red" : "green"}
        >
          {message}
        </Text>
      )}
    </Box>
  );
}
